import httpClient from "./httpClient";

export const listBonds = (params) =>
  httpClient.get("/bonds", { params }).then((r) => r.data);

export const getBond = (id) =>
  httpClient.get(`/bond/${id}`).then((r) => r.data);

export const createProbateBond = (data) =>
  httpClient.post("/create-probate-bond/", data).then((r) => r.data);

export const createGuardianshipBond = (data) =>
  httpClient.post("/create-guardianship-bond/", data).then((r) => r.data);

export const createVABond = (data) =>
  httpClient.post("/create-va-bond/", data).then((r) => r.data);

export const createTrusteeBond = (data) =>
  httpClient.post("/create-trustee-bond/", data).then((r) => r.data);

export const createBlanketBond = (data) =>
  httpClient.post("/create-blanket-bond/", data).then((r) => r.data);

export const approveBond = (id, data) =>
  httpClient.patch(`/approve-bond/${id}/`, data).then((r) => r.data);

export const endorseBond = (data) =>
  httpClient.post("/endorse-bond/", data).then((r) => r.data);

export const cancelBond = (data) =>
  httpClient.post("/cancel-bond/", data).then((r) => r.data);

export const updateBondNumber = (data) =>
  httpClient.patch("/update-bond-number/", data).then((r) => r.data);

export const getBondArchives = (params) =>
  httpClient.get("/bond-archives", { params }).then((r) => r.data);

export const uploadFile = (formData) =>
  httpClient
    .post("/upload-file/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);

export const uploadGIA = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post("/upload-gia/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const uploadLOA = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post("/upload-loa/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
